import React from 'react';
import { buildAdyenStyles } from './buildAdyenStyles';

const STATIC_STYLES = `
  .adyen-checkout-input__inline-validation--invalid { display: none; }
  .adyen-checkout-input__inline-validation--valid { display: none; }
  .loading-input__spinner { display: none !important; }
`;

interface BuildRedcatPaymentStylesParams {
  cardFocusTheme?: React.CSSProperties;
  cardTheme?: React.CSSProperties;
  cardHoverTheme?: React.CSSProperties;
  helperTheme?: React.CSSProperties;
  errorTheme?: React.CSSProperties;
}

export const buildRedcatPaymentStyles = ({
  cardFocusTheme,
  cardTheme,
  cardHoverTheme,
  helperTheme,
  errorTheme,
}: BuildRedcatPaymentStylesParams): React.ReactElement | null => {
  const dynamic = buildAdyenStyles([
    {
      selector: '.adyen-checkout__field',
      vars: {
        '--adyen-sdk-color-background-primary': cardTheme?.backgroundColor,
        '--adyen-sdk-color-outline-tertiary': cardTheme?.borderColor,
        '--adyen-sdk-color-outline-tertiary-active': cardFocusTheme?.borderColor,
        '--adyen-sdk-color-outline-primary-active': cardFocusTheme?.borderColor,
        '--adyen-sdk-color-label-primary': cardTheme?.color,
        '--adyen-sdk-color-label-secondary': cardTheme?.color,
      },
    },
    {
      selector: '.adyen-checkout__input',
      vars: {
        '--adyen-sdk-color-label-primary': cardTheme?.color,
      },
    },
    {
      selector: '.adyen-checkout__input-wrapper:hover',
      vars: {
        '--adyen-sdk-color-outline-tertiary-hover': cardHoverTheme?.borderColor,
      },
    },
    {
      selector: '.adyen-checkout-contextual-text',
      vars: {
        '--adyen-sdk-color-label-primary': helperTheme?.color,
        '--adyen-sdk-text-caption-font-size': helperTheme?.fontSize,
      },
    },
    {
      selector: '.adyen-checkout-disclaimer__label',
      vars: {
        '--adyen-sdk-color-label-secondary': helperTheme?.color,
      },
    },
    {
      selector: '.adyen-checkout__spinner::after',
      vars: {
        '--adyen-sdk-color-outline-primary-active': cardFocusTheme?.borderColor,
      },
    },
    {
      selector: '.adyen-checkout-form-instruction',
      vars: {
        '--adyen-sdk-color-label-primary': helperTheme?.color,
      },
    },
    {
      selector: '.adyen-checkout__field--error',
      vars: {
        '--adyen-sdk-color-label-critical': errorTheme?.color,
        '--adyen-sdk-color-outline-critical': errorTheme?.borderColor,
      },
    },
  ]);

  const css = [dynamic?.props.children, STATIC_STYLES].filter(Boolean).join('\n');
  return <style>{css}</style>;
};
